module.exports = __webpack_public_path__ + "static/images/styles/images/buildings/financial-unit-lvl1-50.d664b364.png";


//////////////////
// WEBPACK FOOTER
// ./styles/images/buildings/financial-unit-lvl1-50.png
// module id = 3526
// module chunks = 11